import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/components/Home'
import Form from '@/components/goelandFormPodp'
import View from '@/components/goelandViewPodp'
import DemandeSansGuid from '@/components/DemandeSansGuid'
import Test from '@/components/Test'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Home
    },
    {
      path: '/demande',
      name: 'DemandeSansGuid',
      component: DemandeSansGuid
    },
    {
      path: '/demande/:guid',
      name: 'goelandFormPodp',
      component: Form,
      props: true
    },
    {
      path: '/view/:guid',
      name: 'goelandViewPodp',
      component: View,
      props: true
    },
    {
      path: '/test',
      name: 'Test',
      component: Test
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js